import {
  GET_ROUTES_CATALOG,
  GET_ROUTES_CATALOG_SUCCESS,
  GET_ROUTES_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const getRoutesCatalogRed = (state: any, actions: any) => {
  switch (actions.type) {
    case GET_ROUTES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_ROUTES_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case GET_ROUTES_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
